<div class="response-actions">
  <button class="icon-btn" (click)="onCopyClick()">
    <img [src]="isCopySucceeded ? 'svg/copilot-response-action-buttons/done.svg' : 'svg/copilot-response-action-buttons/copy.svg' | assetVersion"/>
    <span class="hover-label">Copy</span>
  </button>

  <button class="icon-btn" (click)="onShareClick()">
    <img [src]="'svg/copilot-response-action-buttons/share.svg' | assetVersion" (mouseenter)="isShareHovered = true" (mouseleave)="isShareHovered = false"/>
    <span class="hover-label">Share</span>
    <app-coming-soon class="coming-soon" [isVisible]="isShareHovered" [trianglePosition]="'right'"></app-coming-soon>
  </button>

  <button 
    *ngIf="isGoodResponse || !isBadResponse" class="icon-btn" (click)="onGoodResponseClick()">
    <img [src]="isGoodResponse ? 'svg/copilot-response-action-buttons/like-filled.svg' : 'svg/copilot-response-action-buttons/like.svg' | assetVersion"/>
    <span class="hover-label">Good Response</span>
  </button>

  <button 
    *ngIf="isBadResponse || !isGoodResponse" class="icon-btn" (click)="onBadResponseClick()">
    <img [src]="isBadResponse ? 'svg/copilot-response-action-buttons/dislike-filled.svg' : 'svg/copilot-response-action-buttons/dislike.svg' | assetVersion"/>
    <span class="hover-label">Bad Response</span>
  </button>

  <button *ngIf="shouldDisplayRetryButton" class="icon-btn" (click)="onRetryClick()">
    <img [src]="'svg/copilot-response-action-buttons/retry.svg' | assetVersion"/>
    <span class="hover-label">Retry</span>
  </button>
</div>